/* AthleteSwap Fit — Daten
   1:1 portiert aus lib/fit/kategorien.ts, lib/fit/regeln.ts und
   app/groesse/groessen-daten.ts (athleteswap Next.js-Projekt). Reine Daten,
   keine Logik — die lebt in as-fit-engine.js. Ohne belegte Quelle wird keine
   Größe ausgegeben, siehe Kommentare im Original.

   window.AsFitDaten ist das globale Namespace-Objekt, das alle anderen
   as-fit-*.js-Dateien lesen. */
(function () {
  var HEUTE = "2026-08-08";

  /* ============================================================
     Fit-Kategorien: was gefragt wird, pro Messstrecke
     ============================================================ */
  var FIT_KATEGORIEN = [
    {
      slug: "schlittschuhe",
      shopKategorie: "schlittschuhe",
      name: "Schlittschuhe",
      seiteH1: "Schlittschuhgröße bestimmen",
      seiteBeschreibung:
        "Fußlänge messen und die passende Eishockey-Schlittschuhgröße finden. Größenrechner für Bauer und CCM, Messblatt zum Ausdrucken, verfügbare Paare direkt dazu.",
      kurzHinweis: "Fußlänge messen — die Straßenschuhgröße hilft hier nicht weiter.",
      felder: [
        {
          schluessel: "fussLinksMm",
          label: "Linker Fuß",
          einheit: "cm",
          wozu: "Die Länge bestimmt die Größe.",
          anleitung: "Ferse an die Wand, Gewicht auf den Fuß, bis zur längsten Zehe messen.",
          pflicht: true,
          min: 15,
          max: 35
        },
        {
          schluessel: "fussRechtsMm",
          label: "Rechter Fuß",
          einheit: "cm",
          wozu: "Beide Füße sind selten gleich lang. Wir rechnen mit dem längeren.",
          pflicht: true,
          min: 15,
          max: 35
        },
        {
          schluessel: "fussBreiteMm",
          label: "Fußbreite",
          einheit: "cm",
          wozu: "Bestimmt die Weite — also ob der Schuh seitlich drückt.",
          anleitung: "An der breitesten Stelle des Vorfußes messen, quer über die Ballen.",
          pflicht: false,
          min: 5,
          max: 15
        }
      ],
      sitzHinweis:
        "Im Schuh sollte die Ferse fest sitzen und die längste Zehe die Kappe gerade eben berühren, wenn das Bein gestreckt ist. Beim Beugen zieht sie sich zurück."
    },
    {
      slug: "schulterschutz",
      shopKategorie: "schulterschutz",
      name: "Brustpanzer & Schulterschutz",
      seiteH1: "Brustpanzer und Schulterschutz: die richtige Größe",
      seiteBeschreibung:
        "Körpergröße und Brustumfang messen und die passende Größe für Brustpanzer und Schulterschutz finden. Passende gebrauchte Ausrüstung direkt dazu.",
      kurzHinweis: "Körpergröße und Brustumfang genügen für den Anfang.",
      felder: [
        {
          schluessel: "koerpergroesseCm",
          label: "Körpergröße",
          einheit: "cm",
          wozu: "Grenzt die Größenklasse ein.",
          pflicht: true,
          min: 90,
          max: 220
        },
        {
          schluessel: "brustumfangCm",
          label: "Brustumfang",
          einheit: "cm",
          wozu: "Bestimmt, ob der Schutz eng genug anliegt.",
          anleitung:
            "Maßband waagerecht um die breiteste Stelle des Brustkorbs führen, unter den Achseln durch. Locker anliegen lassen, nicht zusammenziehen.",
          pflicht: true,
          min: 50,
          max: 150
        }
      ],
      sitzHinweis:
        "Die Schulterkappen gehören über die Schulterspitzen, der Schutz liegt eng an, ohne die Armbewegung stark einzuschränken."
    },
    {
      slug: "ellbogenschuetzer",
      shopKategorie: "ellbogenschoner",
      name: "Ellbogenschützer",
      seiteH1: "Ellbogenschützer: die richtige Größe finden",
      seiteBeschreibung:
        "Unterarmlänge und Körpergröße messen und passende Ellbogenschützer finden. Verfügbare gebrauchte Schoner direkt dazu.",
      kurzHinweis: "Unterarmlänge ist der wichtigste Wert.",
      felder: [
        {
          schluessel: "koerpergroesseCm",
          label: "Körpergröße",
          einheit: "cm",
          wozu: "Grenzt die Größenklasse ein.",
          pflicht: true,
          min: 90,
          max: 220
        },
        {
          schluessel: "unterarmCm",
          label: "Unterarmlänge",
          einheit: "cm",
          wozu: "Entscheidet, ob der Schoner die Lücke zum Handschuh schließt.",
          anleitung: "Arm anwinkeln. Von der Mitte des Ellbogens bis zum Handgelenk messen.",
          pflicht: true,
          min: 15,
          max: 45
        },
        {
          schluessel: "bizepsCm",
          label: "Bizepsumfang",
          einheit: "cm",
          wozu: "Nur nötig, wenn der Schoner am Oberarm nicht halten will.",
          pflicht: false,
          min: 15,
          max: 60
        }
      ],
      sitzHinweis:
        "Die Schale sitzt mittig auf dem Ellbogen und rutscht beim Beugen nicht weg. Zwischen Schoner und Handschuh darf keine Lücke bleiben."
    },
    {
      slug: "schienbeinschoner",
      shopKategorie: "schienbeinschoner",
      name: "Schienbeinschoner",
      seiteH1: "Schienbeinschoner: die richtige Länge finden",
      seiteBeschreibung:
        "Bein messen und die passende Schienbeinschoner-Länge in Zoll finden. Passende gebrauchte Schoner direkt dazu.",
      kurzHinweis: "Gemessen wird von der Kniescheibenmitte abwärts.",
      felder: [
        {
          schluessel: "koerpergroesseCm",
          label: "Körpergröße",
          einheit: "cm",
          wozu: "Grenzt die Größenklasse ein.",
          pflicht: true,
          min: 90,
          max: 220
        },
        {
          schluessel: "knieBisKnoechelCm",
          label: "Knie bis Knöchel",
          einheit: "cm",
          wozu: "Bestimmt die Länge des Schoners.",
          anleitung:
            "Im Sitzen, Bein etwa rechtwinklig. Von der Mitte der Kniescheibe bis zur Mitte des äußeren Knöchels messen.",
          pflicht: true,
          min: 15,
          max: 60
        },
        {
          schluessel: "knieBisSchuhCm",
          label: "Knie bis Oberkante Schlittschuh",
          einheit: "cm",
          wozu:
            "Manche Hersteller messen bis zur Zunge des Schlittschuhs statt bis zum Knöchel. Nur nötig, wenn es auf den Zentimeter ankommt.",
          pflicht: false,
          min: 15,
          max: 60
        }
      ],
      sitzHinweis:
        "Die Kniescheibe sitzt mittig in der Schale. Unten sollte der Schoner auf der Zunge des Schlittschuhs aufliegen, oben von der Hose überdeckt werden."
    },
    {
      slug: "eishockeyhose",
      shopKategorie: "hosen",
      name: "Eishockeyhose",
      seiteH1: "Eishockeyhose: die richtige Größe finden",
      seiteBeschreibung:
        "Taillenumfang messen und die passende Eishockeyhose finden. Verfügbare gebrauchte Hosen direkt dazu.",
      kurzHinweis: "Der Taillenumfang ist entscheidend, nicht die Konfektionsgröße.",
      felder: [
        {
          schluessel: "taillenumfangCm",
          label: "Taillenumfang",
          einheit: "cm",
          wozu: "Die Hose muss sicher auf der Taille sitzen.",
          anleitung: "Waagerecht um die schmalste Stelle über dem Beckenknochen messen, locker anliegend.",
          pflicht: true,
          min: 40,
          max: 150
        },
        {
          schluessel: "koerpergroesseCm",
          label: "Körpergröße",
          einheit: "cm",
          wozu: "Grenzt die Größenklasse ein.",
          pflicht: true,
          min: 90,
          max: 220
        },
        {
          schluessel: "huefteBisKnieCm",
          label: "Hüfte bis Knie",
          einheit: "cm",
          wozu: "Nur nötig, wenn die Länge zwischen zwei Größen liegt.",
          pflicht: false,
          min: 20,
          max: 80
        }
      ],
      sitzHinweis:
        "Die Hose sitzt sicher auf der Taille und reicht bis knapp über die Kniescheibe — der Übergang zu den Schienbeinschonern darf keine Lücke lassen."
    },
    {
      slug: "eishockeyschlaeger",
      shopKategorie: "schlaeger",
      name: "Eishockeyschläger",
      seiteH1: "Eishockeyschläger: Länge, Flex und Schusshand",
      seiteBeschreibung:
        "Körpergröße, Gewicht und Schusshand angeben und passende gebrauchte Eishockeyschläger finden.",
      kurzHinweis: "Körpergröße, Gewicht und Schusshand — mehr braucht es nicht.",
      felder: [
        {
          schluessel: "koerpergroesseCm",
          label: "Körpergröße",
          einheit: "cm",
          wozu: "Bestimmt die Länge des Schlägers.",
          pflicht: true,
          min: 90,
          max: 220
        },
        {
          schluessel: "gewichtKg",
          label: "Gewicht",
          einheit: "kg",
          wozu: "Beeinflusst, wie stark sich der Schaft biegen sollte.",
          pflicht: true,
          min: 15,
          max: 150
        },
        {
          schluessel: "schusshand",
          label: "Schusshand",
          einheit: "auswahl",
          wozu: "Ein Linksschläger lässt sich nicht rechts spielen.",
          pflicht: true,
          auswahl: [
            { wert: "links", label: "Links" },
            { wert: "rechts", label: "Rechts" }
          ]
        }
      ],
      sitzHinweis:
        "Als neutrale Ausgangslänge reicht der Schläger ohne Schlittschuhe etwa bis zur Nase, auf Schlittschuhen bis zum Kinn. Wer tiefer steht, nimmt eher kürzer."
    }
  ];

  function fitKategorieFinden(slug) {
    if (!slug) return null;
    for (var i = 0; i < FIT_KATEGORIEN.length; i++) {
      if (FIT_KATEGORIEN[i].slug === slug) return FIT_KATEGORIEN[i];
    }
    return null;
  }

  /* ============================================================
     Regelwerk: Größentabellen je Marke/Kategorie
     ============================================================ */

  function skateBereiche(zeilen) {
    return zeilen.map(function (z, i) {
      return {
        herstellerGroesse: z.groesse,
        eu: z.eu,
        altersklasse: z.klasse,
        bereiche: {
          fussLinksMm: { von: i === 0 ? z.mm - 6 : zeilen[i - 1].mm + 1, bis: z.mm }
        }
      };
    });
  }

  var BAUER_SKATES = [
    { groesse: "Y06", mm: 145, eu: "23,5", klasse: "Youth" },
    { groesse: "Y07", mm: 152, eu: "25", klasse: "Youth" },
    { groesse: "Y08", mm: 162, eu: "26", klasse: "Youth" },
    { groesse: "Y09", mm: 170, eu: "27", klasse: "Youth" },
    { groesse: "Y10", mm: 178, eu: "28", klasse: "Youth" },
    { groesse: "Y10.5", mm: 183, eu: "28,5", klasse: "Youth" },
    { groesse: "Y11", mm: 187, eu: "29,5", klasse: "Youth" },
    { groesse: "Y11.5", mm: 191, eu: "30", klasse: "Youth" },
    { groesse: "Y12", mm: 195, eu: "31", klasse: "Youth" },
    { groesse: "Y13", mm: 203, eu: "32", klasse: "Youth" },
    { groesse: "Y13.5", mm: 207, eu: "33", klasse: "Youth" },
    { groesse: "1", mm: 210, eu: "33,5", klasse: "Junior" },
    { groesse: "1.5", mm: 214, eu: "34", klasse: "Junior" },
    { groesse: "2", mm: 218, eu: "35", klasse: "Junior" },
    { groesse: "2.5", mm: 222, eu: "35,5", klasse: "Junior" },
    { groesse: "3", mm: 226, eu: "36", klasse: "Junior" },
    { groesse: "3.5", mm: 231, eu: "36,5", klasse: "Junior" },
    { groesse: "4", mm: 235, eu: "37,5", klasse: "Intermediate" },
    { groesse: "4.5", mm: 239, eu: "38", klasse: "Intermediate" },
    { groesse: "5", mm: 243, eu: "38,5", klasse: "Intermediate" },
    { groesse: "5.5", mm: 247, eu: "39", klasse: "Intermediate" },
    { groesse: "6", mm: 251, eu: "40,5", klasse: "Intermediate" },
    { groesse: "6.5", mm: 255, eu: "41", klasse: "Intermediate" },
    { groesse: "7", mm: 260, eu: "42", klasse: "Senior" },
    { groesse: "7.5", mm: 264, eu: "42,5", klasse: "Senior" },
    { groesse: "8", mm: 268, eu: "43", klasse: "Senior" },
    { groesse: "8.5", mm: 272, eu: "44", klasse: "Senior" },
    { groesse: "9", mm: 277, eu: "44,5", klasse: "Senior" },
    { groesse: "9.5", mm: 281, eu: "45", klasse: "Senior" },
    { groesse: "10", mm: 285, eu: "45,5", klasse: "Senior" },
    { groesse: "10.5", mm: 289, eu: "46", klasse: "Senior" },
    { groesse: "11", mm: 294, eu: "47", klasse: "Senior" },
    { groesse: "11.5", mm: 298, eu: "47,5", klasse: "Senior" },
    { groesse: "12", mm: 302, eu: "48", klasse: "Senior" },
    { groesse: "13", mm: 310, eu: "49", klasse: "Senior" },
    { groesse: "14", mm: 318, eu: "50", klasse: "Senior" },
    { groesse: "15", mm: 326, eu: "51", klasse: "Senior" }
  ];

  var CCM_SKATES = [
    { groesse: "6 Jr", mm: 145, eu: "24", klasse: "Youth" },
    { groesse: "7 Jr", mm: 152, eu: "25", klasse: "Youth" },
    { groesse: "8 Jr", mm: 162, eu: "26", klasse: "Youth" },
    { groesse: "8.5 Jr", mm: 165, eu: "26,5", klasse: "Youth" },
    { groesse: "9 Jr", mm: 170, eu: "27", klasse: "Youth" },
    { groesse: "9.5 Jr", mm: 174, eu: "27,5", klasse: "Youth" },
    { groesse: "10 Jr", mm: 178, eu: "28", klasse: "Youth" },
    { groesse: "10.5 Jr", mm: 182, eu: "29", klasse: "Youth" },
    { groesse: "11 Jr", mm: 187, eu: "29,5", klasse: "Youth" },
    { groesse: "12 Jr", mm: 195, eu: "31", klasse: "Youth" },
    { groesse: "12.5 Jr", mm: 199, eu: "31,5", klasse: "Youth" },
    { groesse: "13 Jr", mm: 203, eu: "32", klasse: "Youth" },
    { groesse: "13.5 Jr", mm: 206, eu: "33", klasse: "Youth" },
    { groesse: "1", mm: 210, eu: "33,5", klasse: "Junior" },
    { groesse: "1.5", mm: 214, eu: "34", klasse: "Junior" },
    { groesse: "2", mm: 216, eu: "35", klasse: "Junior" },
    { groesse: "2.5", mm: 218, eu: "35,5", klasse: "Junior" },
    { groesse: "3", mm: 226, eu: "36", klasse: "Junior" },
    { groesse: "3.5", mm: 229, eu: "36,5", klasse: "Junior" },
    { groesse: "4", mm: 235, eu: "37,5", klasse: "Junior" },
    { groesse: "4.5", mm: 239, eu: "38", klasse: "Junior" },
    { groesse: "5", mm: 243, eu: "38,5", klasse: "Junior" },
    { groesse: "5.5", mm: 247, eu: "39", klasse: "Junior" },
    { groesse: "6", mm: 251, eu: "40,5", klasse: "Senior" },
    { groesse: "6.5", mm: 255, eu: "41", klasse: "Senior" },
    { groesse: "7", mm: 260, eu: "42", klasse: "Senior" },
    { groesse: "7.5", mm: 264, eu: "42,5", klasse: "Senior" },
    { groesse: "8", mm: 268, eu: "43", klasse: "Senior" },
    { groesse: "8.5", mm: 272, eu: "44", klasse: "Senior" },
    { groesse: "9", mm: 277, eu: "44,5", klasse: "Senior" },
    { groesse: "9.5", mm: 281, eu: "45", klasse: "Senior" },
    { groesse: "10", mm: 288, eu: "45,5", klasse: "Senior" },
    { groesse: "10.5", mm: 289, eu: "46", klasse: "Senior" },
    { groesse: "11", mm: 296, eu: "47", klasse: "Senior" },
    { groesse: "11.5", mm: 298, eu: "47,5", klasse: "Senior" },
    { groesse: "12", mm: 302, eu: "48", klasse: "Senior" },
    { groesse: "12.5", mm: 305, eu: "48,5", klasse: "Senior" },
    { groesse: "13", mm: 308, eu: "49", klasse: "Senior" },
    { groesse: "13.5", mm: 310, eu: "50", klasse: "Senior" },
    { groesse: "14", mm: 318, eu: "51", klasse: "Senior" }
  ];

  var WEITEN_BAUER = [
    { kuerzel: "Fit 1", text: "schmal" },
    { kuerzel: "Fit 2", text: "normal" },
    { kuerzel: "Fit 3", text: "breit" }
  ];
  var WEITEN_CCM = [
    { kuerzel: "C", text: "schmal" },
    { kuerzel: "D", text: "normal" },
    { kuerzel: "R", text: "breiter als D" },
    { kuerzel: "E", text: "extra breit" },
    { kuerzel: "EE", text: "am breitesten" }
  ];

  function regel(groesse, klasse, bereiche) {
    return { herstellerGroesse: groesse, altersklasse: klasse, bereiche: bereiche };
  }
  function bis(von, b) {
    return { von: von, bis: b };
  }

  var REGELSAETZE = [
    {
      kategorie: "schlittschuhe",
      marke: "Bauer",
      quelle: {
        art: "hersteller",
        bezeichnung: "Bauer Player Skates Size Chart (METRIC)",
        geprueftAm: HEUTE,
        notiz: "Der angegebene Wert ist die maximale Fußlänge einer Größe."
      },
      groessen: skateBereiche(BAUER_SKATES)
    },
    {
      kategorie: "schlittschuhe",
      marke: "CCM",
      quelle: {
        art: "hersteller",
        bezeichnung: "CCM Size Guide, Mondopoint in Millimetern",
        geprueftAm: HEUTE,
        notiz: "CCM weicht in Einzelgrößen um wenige Millimeter von Bauer ab, etwa bei 2, 3.5 und 10."
      },
      groessen: skateBereiche(CCM_SKATES)
    },
    {
      kategorie: "schulterschutz",
      marke: "Bauer",
      quelle: { art: "hersteller", bezeichnung: "Bauer Shoulder Pad Size Chart", geprueftAm: HEUTE, notiz: "Bemessen nach Brustumfang und Körpergröße." },
      groessen: [
        regel("Youth XS", "Youth", { brustumfangCm: bis(53, 64), koerpergroesseCm: bis(91, 116) }),
        regel("Youth S", "Youth", { brustumfangCm: bis(56, 66), koerpergroesseCm: bis(98, 124) }),
        regel("Youth M", "Youth", { brustumfangCm: bis(58, 69), koerpergroesseCm: bis(109, 132) }),
        regel("Youth L", "Youth", { brustumfangCm: bis(61, 71), koerpergroesseCm: bis(114, 140) }),
        regel("Junior S", "Junior", { brustumfangCm: bis(66, 76), koerpergroesseCm: bis(130, 142) }),
        regel("Junior M", "Junior", { brustumfangCm: bis(71, 81), koerpergroesseCm: bis(140, 152) }),
        regel("Junior L", "Junior", { brustumfangCm: bis(76, 86), koerpergroesseCm: bis(150, 163) }),
        regel("Senior S", "Senior", { brustumfangCm: bis(91, 102), koerpergroesseCm: bis(165, 175) }),
        regel("Senior M", "Senior", { brustumfangCm: bis(97, 107), koerpergroesseCm: bis(170, 180) }),
        regel("Senior L", "Senior", { brustumfangCm: bis(102, 112), koerpergroesseCm: bis(175, 185) }),
        regel("Senior XL", "Senior", { brustumfangCm: bis(107, 117), koerpergroesseCm: bis(180, 190) })
      ]
    },
    {
      kategorie: "schulterschutz",
      marke: "CCM",
      quelle: { art: "hersteller", bezeichnung: "CCM Shoulder Pad Size Guide", geprueftAm: HEUTE, notiz: "Bemessen nach Körpergröße und Brustumfang." },
      groessen: [
        regel("Child S", "Kids (Yth)", { koerpergroesseCm: bis(100, 110), brustumfangCm: bis(51, 61) }),
        regel("Child M", "Kids (Yth)", { koerpergroesseCm: bis(110, 120), brustumfangCm: bis(56, 66) }),
        regel("Child L", "Kids (Yth)", { koerpergroesseCm: bis(120, 130), brustumfangCm: bis(61, 71) }),
        regel("Junior S", "Junior", { koerpergroesseCm: bis(130, 140), brustumfangCm: bis(66, 76) }),
        regel("Junior M", "Junior", { koerpergroesseCm: bis(135, 145), brustumfangCm: bis(71, 81) }),
        regel("Junior L", "Junior", { koerpergroesseCm: bis(140, 150), brustumfangCm: bis(81, 91) }),
        regel("Senior S", "Senior", { koerpergroesseCm: bis(152, 172), brustumfangCm: bis(86, 96) }),
        regel("Senior M", "Senior", { koerpergroesseCm: bis(162, 183), brustumfangCm: bis(97, 107) }),
        regel("Senior L", "Senior", { koerpergroesseCm: bis(172, 193), brustumfangCm: bis(107, 117) }),
        regel("Senior XL", "Senior", { koerpergroesseCm: bis(183, 210), brustumfangCm: bis(117, 127) })
      ]
    },
    {
      kategorie: "schulterschutz",
      marke: "Warrior",
      quelle: {
        art: "hersteller",
        bezeichnung: "Warrior Shoulder Protection Size Guide",
        geprueftAm: HEUTE,
        notiz: "Warrior bemisst ausschließlich nach Körpergröße. Large und X-Large sind in der Quelle identisch angegeben, deshalb ist X-Large hier nicht hinterlegt."
      },
      groessen: [
        regel("Minior S", "Kids (Yth)", { koerpergroesseCm: bis(99, 124) }),
        regel("Minior L", "Kids (Yth)", { koerpergroesseCm: bis(111, 135) }),
        regel("Junior S", "Junior", { koerpergroesseCm: bis(129, 142) }),
        regel("Junior L", "Junior", { koerpergroesseCm: bis(137, 155) }),
        regel("Intermediate S", "Junior", { koerpergroesseCm: bis(152, 165) }),
        regel("Intermediate L", "Junior", { koerpergroesseCm: bis(163, 175) }),
        regel("Senior M", "Senior", { koerpergroesseCm: bis(168, 183) }),
        regel("Senior L", "Senior", { koerpergroesseCm: bis(175, 188) })
      ]
    },
    {
      kategorie: "ellbogenschuetzer",
      marke: "Bauer",
      quelle: {
        art: "hersteller",
        bezeichnung: "Bauer Elbow Pad Size Chart",
        geprueftAm: HEUTE,
        notiz: "Bemessen nach Unterarmlänge und Körpergröße."
      },
      groessen: [
        regel("Youth S", "Youth", { unterarmCm: bis(18, 20), koerpergroesseCm: bis(98, 124) }),
        regel("Youth M", "Youth", { unterarmCm: bis(19, 22), koerpergroesseCm: bis(109, 132) }),
        regel("Youth L", "Youth", { unterarmCm: bis(20, 23), koerpergroesseCm: bis(114, 140) }),
        regel("Junior S", "Junior", { unterarmCm: bis(23, 28), koerpergroesseCm: bis(130, 142) }),
        regel("Junior L", "Junior", { unterarmCm: bis(25, 30), koerpergroesseCm: bis(150, 163) })
      ]
    },
    {
      kategorie: "ellbogenschuetzer",
      marke: "CCM",
      quelle: { art: "hersteller", bezeichnung: "CCM Elbow Pad Size Guide", geprueftAm: HEUTE, notiz: "CCM bemisst ausschließlich nach Körpergröße." },
      groessen: [
        regel("Child S", "Kids (Yth)", { koerpergroesseCm: bis(100, 110) }),
        regel("Child M", "Kids (Yth)", { koerpergroesseCm: bis(110, 120) }),
        regel("Child L", "Kids (Yth)", { koerpergroesseCm: bis(120, 130) }),
        regel("Junior S", "Junior", { koerpergroesseCm: bis(130, 140) }),
        regel("Junior M", "Junior", { koerpergroesseCm: bis(135, 145) }),
        regel("Junior L", "Junior", { koerpergroesseCm: bis(140, 150) }),
        regel("Senior S", "Senior", { koerpergroesseCm: bis(152, 172) }),
        regel("Senior M", "Senior", { koerpergroesseCm: bis(162, 183) }),
        regel("Senior L", "Senior", { koerpergroesseCm: bis(172, 193) }),
        regel("Senior XL", "Senior", { koerpergroesseCm: bis(188, 210) })
      ]
    },
    {
      kategorie: "ellbogenschuetzer",
      marke: "Warrior",
      quelle: {
        art: "hersteller",
        bezeichnung: "Warrior Elbow Pads Size Guide",
        geprueftAm: HEUTE,
        notiz: "Warrior bemisst ausschließlich nach Körpergröße. Large und X-Large sind in der Quelle identisch angegeben, deshalb ist X-Large hier nicht hinterlegt."
      },
      groessen: [
        regel("Minior S", "Kids (Yth)", { koerpergroesseCm: bis(99, 124) }),
        regel("Minior L", "Kids (Yth)", { koerpergroesseCm: bis(111, 135) }),
        regel("Junior S", "Junior", { koerpergroesseCm: bis(129, 142) }),
        regel("Junior L", "Junior", { koerpergroesseCm: bis(137, 155) }),
        regel("Intermediate S", "Junior", { koerpergroesseCm: bis(152, 165) }),
        regel("Intermediate L", "Junior", { koerpergroesseCm: bis(163, 175) }),
        regel("Senior M", "Senior", { koerpergroesseCm: bis(168, 183) }),
        regel("Senior L", "Senior", { koerpergroesseCm: bis(175, 188) })
      ]
    },
    {
      kategorie: "schienbeinschoner",
      marke: "Bauer",
      quelle: {
        art: "hersteller",
        bezeichnung: "Bauer Shin Guard Size Chart",
        geprueftAm: HEUTE,
        notiz: "Bauer bemisst nach Beinlänge (Knie bis Knöchel) und Körpergröße — nicht nach Körpergröße allein wie CCM und Warrior."
      },
      groessen: [
        regel('Youth S-7"', "Youth", { knieBisKnoechelCm: bis(15, 18), koerpergroesseCm: bis(98, 124) }),
        regel('Youth M-8"', "Youth", { knieBisKnoechelCm: bis(18, 20), koerpergroesseCm: bis(109, 132) }),
        regel('Youth L-9"', "Youth", { knieBisKnoechelCm: bis(20, 23), koerpergroesseCm: bis(114, 140) }),
        regel('Junior S-10"', "Junior", { knieBisKnoechelCm: bis(23, 28), koerpergroesseCm: bis(130, 142) }),
        regel('Junior M-11"', "Junior", { knieBisKnoechelCm: bis(25, 28), koerpergroesseCm: bis(140, 152) }),
        regel('Junior L-12"', "Junior", { knieBisKnoechelCm: bis(25, 30), koerpergroesseCm: bis(150, 163) }),
        regel('Senior S-13"', "Senior", { knieBisKnoechelCm: bis(30, 33), koerpergroesseCm: bis(165, 175) }),
        regel('Senior M-14"', "Senior", { knieBisKnoechelCm: bis(33, 36), koerpergroesseCm: bis(170, 180) }),
        regel('Senior L-15"', "Senior", { knieBisKnoechelCm: bis(36, 38), koerpergroesseCm: bis(175, 185) }),
        regel('Senior XL-16"', "Senior", { knieBisKnoechelCm: bis(38, 41), koerpergroesseCm: bis(180, 190) }),
        regel('Senior XXL-17"', "Senior", { knieBisKnoechelCm: bis(41, 43), koerpergroesseCm: bis(185, 198) })
      ]
    },
    {
      kategorie: "schienbeinschoner",
      marke: "CCM",
      quelle: {
        art: "hersteller",
        bezeichnung: "CCM Shin Guard Size Guide",
        geprueftAm: HEUTE,
        notiz: "CCM bemisst nach Körpergröße; die Zoll-Zahl ist die Baulänge des Schoners."
      },
      groessen: [
        regel('8"', "Kids (Yth)", { koerpergroesseCm: bis(100, 110) }),
        regel('9"', "Kids (Yth)", { koerpergroesseCm: bis(110, 120) }),
        regel('10"', "Kids (Yth)", { koerpergroesseCm: bis(120, 130) }),
        regel('11"', "Junior", { koerpergroesseCm: bis(130, 140) }),
        regel('12"', "Junior", { koerpergroesseCm: bis(140, 150) }),
        regel('13"', "Junior", { koerpergroesseCm: bis(150, 160) }),
        regel('14"', "Senior", { koerpergroesseCm: bis(162, 172) }),
        regel('15"', "Senior", { koerpergroesseCm: bis(172, 183) }),
        regel('16"', "Senior", { koerpergroesseCm: bis(183, 193) })
      ]
    },
    {
      kategorie: "schienbeinschoner",
      marke: "Warrior",
      quelle: { art: "hersteller", bezeichnung: "Warrior Leg Protection Size Guide", geprueftAm: HEUTE, notiz: "Warrior bemisst nach Körpergröße." },
      groessen: [
        regel('8"', "Kids (Yth)", { koerpergroesseCm: bis(102, 112) }),
        regel('9"', "Kids (Yth)", { koerpergroesseCm: bis(112, 122) }),
        regel('10"', "Junior", { koerpergroesseCm: bis(122, 134) }),
        regel('11"', "Junior", { koerpergroesseCm: bis(132, 142) }),
        regel('12"', "Junior", { koerpergroesseCm: bis(142, 158) }),
        regel('13"', "Junior", { koerpergroesseCm: bis(158, 168) }),
        regel('15"', "Senior", { koerpergroesseCm: bis(170, 178) }),
        regel('16"', "Senior", { koerpergroesseCm: bis(178, 188) }),
        regel('17"', "Senior", { koerpergroesseCm: bis(183, 210) })
      ]
    },
    {
      kategorie: "eishockeyhose",
      marke: "Bauer",
      quelle: {
        art: "hersteller",
        bezeichnung: "Bauer Hockey Pants Size Chart",
        geprueftAm: HEUTE,
        notiz: "Bemessen nach Taillenumfang und Körpergröße."
      },
      groessen: [
        regel("Youth XS", "Youth", { taillenumfangCm: bis(51, 56), koerpergroesseCm: bis(91, 116) }),
        regel("Youth S", "Youth", { taillenumfangCm: bis(51, 56), koerpergroesseCm: bis(98, 124) }),
        regel("Youth M", "Youth", { taillenumfangCm: bis(53, 58), koerpergroesseCm: bis(109, 132) }),
        regel("Youth L", "Youth", { taillenumfangCm: bis(53, 58), koerpergroesseCm: bis(114, 140) }),
        regel("Junior XS", "Junior", { taillenumfangCm: bis(56, 58), koerpergroesseCm: bis(124, 140) }),
        regel("Junior S", "Junior", { taillenumfangCm: bis(56, 61) }),
        regel("Junior M", "Junior", { taillenumfangCm: bis(61, 66), koerpergroesseCm: bis(140, 152) }),
        regel("Junior L", "Junior", { taillenumfangCm: bis(66, 71), koerpergroesseCm: bis(150, 163) }),
        regel("Junior XL", "Junior", { taillenumfangCm: bis(71, 76), koerpergroesseCm: bis(160, 172) }),
        regel("Senior S", "Senior", { taillenumfangCm: bis(76, 86), koerpergroesseCm: bis(165, 175) }),
        regel("Senior M", "Senior", { taillenumfangCm: bis(81, 91), koerpergroesseCm: bis(170, 180) }),
        regel("Senior L", "Senior", { taillenumfangCm: bis(86, 97), koerpergroesseCm: bis(175, 185) }),
        regel("Senior XL", "Senior", { taillenumfangCm: bis(91, 102), koerpergroesseCm: bis(180, 191) })
      ]
    },
    {
      kategorie: "eishockeyhose",
      marke: "CCM",
      quelle: { art: "hersteller", bezeichnung: "CCM Hockey Pants Size Guide", geprueftAm: HEUTE, notiz: "Bemessen nach Taillenumfang und Körpergröße." },
      groessen: [
        regel("Child S", "Kids (Yth)", { taillenumfangCm: bis(51, 56), koerpergroesseCm: bis(102, 110) }),
        regel("Child M", "Kids (Yth)", { taillenumfangCm: bis(53, 58), koerpergroesseCm: bis(110, 122) }),
        regel("Child L", "Kids (Yth)", { taillenumfangCm: bis(56, 61), koerpergroesseCm: bis(122, 132) }),
        regel("Junior S", "Junior", { taillenumfangCm: bis(56, 61), koerpergroesseCm: bis(122, 137) }),
        regel("Junior M", "Junior", { taillenumfangCm: bis(61, 66), koerpergroesseCm: bis(132, 152) }),
        regel("Junior L", "Junior", { taillenumfangCm: bis(66, 71), koerpergroesseCm: bis(142, 162) }),
        regel("Junior XL", "Junior", { taillenumfangCm: bis(71, 76), koerpergroesseCm: bis(157, 172) }),
        regel("Senior S", "Senior", { taillenumfangCm: bis(76, 86), koerpergroesseCm: bis(152, 172) }),
        regel("Senior M", "Senior", { taillenumfangCm: bis(81, 92), koerpergroesseCm: bis(162, 183) }),
        regel("Senior L", "Senior", { taillenumfangCm: bis(86, 97), koerpergroesseCm: bis(172, 193) }),
        regel("Senior XL", "Senior", { taillenumfangCm: bis(92, 103), koerpergroesseCm: bis(183, 210) })
      ]
    },
    {
      kategorie: "eishockeyschlaeger",
      marke: "Bauer",
      quelle: {
        art: "hersteller",
        bezeichnung: "Bauer Stick Flex Guide",
        geprueftAm: HEUTE,
        notiz: "Bemessen nach Körpergröße und Gewicht. Warrior gibt dieselbe Tabelle an. Wurde ein gebrauchter Schläger gekürzt, verhält er sich steifer als der aufgedruckte Flex."
      },
      groessen: [
        regel("30 Flex", "Kids (Yth)", { koerpergroesseCm: bis(89, 117), gewichtKg: bis(11, 22) }),
        regel("35 Flex", "Kids (Yth)", { koerpergroesseCm: bis(102, 124), gewichtKg: bis(13, 27) }),
        regel("35/40 Flex", "Youth", { koerpergroesseCm: bis(119, 137), gewichtKg: bis(15, 34) }),
        regel("45/47 Flex", "Junior", { koerpergroesseCm: bis(124, 145), gewichtKg: bis(36, 45) }),
        regel("50/52 Flex", "Junior", { koerpergroesseCm: bis(132, 155), gewichtKg: bis(40, 49) }),
        regel("60 Flex", "Junior", { koerpergroesseCm: bis(132, 163), gewichtKg: bis(49, 58) }),
        regel("67 Flex", "Junior", { koerpergroesseCm: bis(137, 168), gewichtKg: bis(54, 63) }),
        regel("75 Flex", "Junior", { koerpergroesseCm: bis(145, 170), gewichtKg: bis(63, 72) }),
        regel("77 Flex", "Senior", { koerpergroesseCm: bis(165, 180), gewichtKg: bis(63, 77) }),
        regel("87 Flex", "Senior", { koerpergroesseCm: bis(168, 185), gewichtKg: bis(72, 86) }),
        regel("95 Flex", "Senior", { koerpergroesseCm: bis(170, 188), gewichtKg: bis(79, 92) }),
        regel("102 Flex", "Senior", { koerpergroesseCm: bis(175, 191), gewichtKg: bis(86, 99) }),
        regel("112 Flex", "Senior", { koerpergroesseCm: bis(180, 220), gewichtKg: bis(95, 200) })
      ]
    }
  ];

  function regelsaetzeFuer(kategorie) {
    return REGELSAETZE.filter(function (r) {
      return r.kategorie === kategorie;
    });
  }

  /* ============================================================
     Schlittschuh-Schnellrechner (Startbereich der /groesse-Seite)
     ============================================================ */
  var GROESSEN = [
    { skate: "1.5", eu: "34", minMm: 210, maxMm: 214 },
    { skate: "2.0", eu: "35", minMm: 215, maxMm: 218 },
    { skate: "2.5", eu: "35,5", minMm: 219, maxMm: 222 },
    { skate: "3.0", eu: "36", minMm: 223, maxMm: 226 },
    { skate: "3.5", eu: "36,5", minMm: 227, maxMm: 231 },
    { skate: "4.0", eu: "37,5", minMm: 232, maxMm: 235 },
    { skate: "4.5", eu: "38", minMm: 236, maxMm: 239 },
    { skate: "5.0", eu: "38,5", minMm: 240, maxMm: 243 },
    { skate: "5.5", eu: "39", minMm: 244, maxMm: 247 },
    { skate: "6.0", eu: "40,5", minMm: 248, maxMm: 251 },
    { skate: "6.5", eu: "41", minMm: 252, maxMm: 255 },
    { skate: "7.0", eu: "42", minMm: 256, maxMm: 260 }
  ];
  var KERNGROESSEN = ["3.0", "3.5", "4.0", "4.5", "5.0", "5.5", "6.0"];
  var JUGEND = [
    { skate: "Y06", eu: "23,5", minMm: 139, maxMm: 145 },
    { skate: "Y07", eu: "25", minMm: 146, maxMm: 152 },
    { skate: "Y08", eu: "26", minMm: 153, maxMm: 162 },
    { skate: "Y09", eu: "27", minMm: 163, maxMm: 170 },
    { skate: "Y10", eu: "28", minMm: 171, maxMm: 178 },
    { skate: "Y10.5", eu: "28,5", minMm: 179, maxMm: 183 },
    { skate: "Y11", eu: "29,5", minMm: 184, maxMm: 187 },
    { skate: "Y11.5", eu: "30", minMm: 188, maxMm: 191 },
    { skate: "Y12", eu: "31", minMm: 192, maxMm: 195 },
    { skate: "Y13", eu: "32", minMm: 196, maxMm: 203 },
    { skate: "Y13.5", eu: "33", minMm: 204, maxMm: 207 }
  ];

  function formatCm(mm) {
    return (mm / 10).toFixed(1).replace(".", ",");
  }
  function bereichText(g) {
    return formatCm(g.minMm) + " – " + formatCm(g.maxMm) + " cm";
  }
  function findeGroesse(mm) {
    for (var i = 0; i < GROESSEN.length; i++) {
      if (mm >= GROESSEN[i].minMm && mm <= GROESSEN[i].maxMm) return GROESSEN[i];
    }
    return null;
  }
  function parseLaenge(eingabe) {
    var wert = parseFloat(String(eingabe).replace(",", "."));
    if (!isFinite(wert) || wert <= 0) return null;
    return Math.round(wert * 10);
  }

  window.AsFitDaten = {
    FIT_KATEGORIEN: FIT_KATEGORIEN,
    fitKategorieFinden: fitKategorieFinden,
    REGELSAETZE: REGELSAETZE,
    regelsaetzeFuer: regelsaetzeFuer,
    WEITEN_BAUER: WEITEN_BAUER,
    WEITEN_CCM: WEITEN_CCM,
    GROESSEN: GROESSEN,
    JUGEND: JUGEND,
    KERNGROESSEN: KERNGROESSEN,
    formatCm: formatCm,
    bereichText: bereichText,
    findeGroesse: findeGroesse,
    parseLaenge: parseLaenge
  };
})();
